/* Sección 17: grid de reseñas estilo Loox (port del reviews-grid-3x1 del
   theme live de MX). Vanilla, scoped por [data-skr-root], sin llamadas a
   la app de Revie: todo sale de los <script type="application/json"> que
   emite la sección desde los metafields.

   Cambios de ES sobre el port (Mau, sesión 5):
   - Reseñas DESTACADAS: data-skr-featured trae claves "nombre|fecha"
     separadas por ; — esas reseñas suben al principio en ese orden y el
     resto conserva el orden original. Una clave sin match se ignora.
   - Paginación ampliada: ventana de ±2 páginas y botones « primera /
     última » además de ‹ › y los números.
   - Formato es-ES y estrella vacía por clase (color según la banda). */

(function () {
  function initSkr(root) {
    if (root.dataset.skrInit === '1') return;
    root.dataset.skrInit = '1';

    function q(sel) { return root.querySelector(sel); }
    // Metafields legacy: | json puede salir doble-encodeado -> re-parsear.
    function pj(sel) {
      var el = q(sel);
      if (!el) return null;
      var d = JSON.parse(el.textContent);
      if (typeof d === 'string') { d = JSON.parse(d); }
      return d;
    }

    var data, list;
    try { data = pj('[data-skr-data]'); list = pj('[data-skr-list]'); } catch (e) { return; }
    if (!data || !list || !list.length) { return; }

    // Destacadas primero (curación de sesión 5), resto en su orden.
    function keyOf(r) {
      return (((r.customer || {}).firstName) || '').trim() + '|' + String(r.createdAt || '').slice(0, 10);
    }
    var FEAT = (root.getAttribute('data-skr-featured') || '').split(';')
      .map(function (s) { return s.trim(); })
      .filter(function (s) { return s.length > 0; });
    if (FEAT.length) {
      var rank = {};
      FEAT.forEach(function (k, i) { rank[k] = i; });
      list = list
        .map(function (r, i) { return { r: r, i: i }; })
        .sort(function (a, b) {
          var ra = rank[keyOf(a.r)]; if (ra === undefined) { ra = FEAT.length + a.i; }
          var rb = rank[keyOf(b.r)]; if (rb === undefined) { rb = FEAT.length + b.i; }
          return ra - rb;
        })
        .map(function (x) { return x.r; });
    }

    var PER = parseInt(root.getAttribute('data-skr-per'), 10) || 18;
    var page = 1, pages = Math.ceil(list.length / PER);
    /* Separador de miles SIEMPRE ("5.203"): Intl es-ES no agrupa números
       de 4 cifras (CLDR) y el estilo de la marca sí ("350.000+"). */
    var nf = { format: function (n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); } };
    /* Plantillas de kit y brocha (misión L2): miles con coma, como en México, y la fecha real de cada reseña. */
    var realDates = root.hasAttribute('data-skr-real-dates');
    if (realDates) { nf = { format: function (n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); } }; }
    var MES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    /* Override VISUAL de año, IDÉNTICO al del bottom sheet
       (js-reviews-sheet.js) para que la misma reseña diga lo mismo en los
       dos sitios (Mau, 2026-08-07): 2024 se muestra 2025 siempre; 2025 se
       muestra 2026 SOLO ene-ago (sep-dic se queda: 2026 sep-dic sería
       futuro). Sustituye al parche de sesión 7 que forzaba 2026 en los 15
       primeros — con dos reglas distintas, muro y sheet se contradecían.
       El dato real del metafield no se toca. Si se cambia la regla aquí,
       cambiarla TAMBIÉN en js-reviews-sheet.js. */
    function fdate(s) {
      var d = new Date(s);
      if (isNaN(d)) { return ''; }
      var y = d.getFullYear();
      var m = d.getMonth(); /* 0-11; agosto = 7 */
      if (realDates) { return d.getDate() + ' ' + MES[m] + ' ' + y; }
      if (y === 2024) { y = 2025; }
      else if (y === 2025 && m <= 7) { y = 2026; }
      return d.getDate() + ' ' + MES[m] + ' ' + y;
    }
    function stars(n) { var f = '', e = '', i; for (i = 0; i < 5; i++) { if (i < n) { f += '★'; } else { e += '☆'; } } return f + '<span class="skr-star-off">' + e + '</span>'; }
    var CHECK = '<svg width="13" height="13" viewBox="0 0 16 16" fill="none" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="#12D385"/><path d="M4.5 8.2l2.3 2.3 4.7-4.7" stroke="#fff" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    function esc(s) { return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

    // Resumen + desglose de estrellas (desplegable). El override del
    // setting manda sobre el promedio del metafield.
    var avg = Number(root.getAttribute('data-skr-avg-override')) || Number(data.reviewAverageValue || 0);
    q('[data-skr-avg]').textContent = (Math.round(avg * 10) / 10).toFixed(1);
    q('[data-skr-count]').textContent = nf.format(data.reviewCount || list.length) + ' reseñas verificadas';
    var br = q('[data-skr-break]'), tot = 0, i;
    var starsArr = (data.stars || []).slice().sort(function (a, b) { return Number(b.star) - Number(a.star); });
    for (i = 0; i < starsArr.length; i++) { tot += Number(starsArr[i].count); }
    var bh = '';
    for (i = 0; i < starsArr.length; i++) {
      var pc = tot ? Math.max(1, Math.round(Number(starsArr[i].count) / tot * 100)) : 0;
      bh += '<div class="skr-brow"><span class="skr-brow-l">' + starsArr[i].star + ' ★</span><span class="skr-bar"><i style="width:' + pc + '%"></i></span><span class="skr-brow-c">' + nf.format(starsArr[i].count) + '</span></div>';
    }
    br.innerHTML = bh;
    var sum = q('[data-skr-sum]'), head = sum.parentElement;
    function tgl() { var on = head.classList.toggle('skr-open'); sum.setAttribute('aria-expanded', on ? 'true' : 'false'); }
    sum.addEventListener('click', tgl);
    sum.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tgl(); } });

    // Lightbox de fotos.
    var lb = q('[data-skr-lb]'), lbi = q('[data-skr-lb-img]'), lbc = q('[data-skr-lb-cap]');
    function lbOpen(src, cap) { lbi.src = src; lbc.textContent = cap; lb.classList.add('skr-on'); document.body.style.overflow = 'hidden'; }
    function lbClose() { if (!lb.classList.contains('skr-on')) return; lb.classList.remove('skr-on'); lbi.removeAttribute('src'); document.body.style.overflow = ''; }
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.hasAttribute('data-skr-lb-x')) { lbClose(); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { lbClose(); } });

    // Grid (masonry por CSS columns).
    var grid = q('[data-skr-grid]');
    function render() {
      var start = (page - 1) * PER, slice = list.slice(start, start + PER), h = '', k;
      for (k = 0; k < slice.length; k++) {
        var r = slice[k], name = esc(((r.customer && r.customer.firstName) || '') + (r.customer && r.customer.lastName ? ' ' + String(r.customer.lastName).charAt(0) + '.' : '')).trim() || 'Clienta';
        var img = (r.images || []).filter(function (x) { return x.active; })[0];
        var aud = (r.audio || []).filter(function (x) { return x.active; })[0];
        var comment = esc((r.comment || '').trim());
        var long = comment.length > 190;
        /* La fecha sale de fdate, que ya trae el override global de año
           (2026-08-07). El parche anterior de "2026 en los 15 primeros"
           (sesión 7) se retiró: contradecía al bottom sheet. */
        var shownDate = fdate(r.createdAt);
        h += '<div class="skr-card">';
        if (img) { h += '<img class="skr-img" loading="lazy" src="' + esc(img.src) + '" alt="Foto de la reseña de ' + name + '" data-cap="' + comment.slice(0, 160) + '">'; }
        h += '<div class="skr-body"><span class="skr-cstars">' + stars(Number(r.stars) || 5) + '</span>';
        if (aud) { h += '<audio controls preload="none" src="' + esc(aud.src) + '"></audio>'; }
        if (comment) { h += '<p class="skr-ctext' + (long ? ' skr-clamp' : '') + '">' + comment + '</p>' + (long ? '<span class="skr-more">Leer más</span>' : ''); }
        h += '<div class="skr-cfoot"><span class="skr-cname">' + name + '</span>' + CHECK + '<span class="skr-cdate">' + shownDate + '</span></div></div></div>';
      }
      grid.innerHTML = h;
      renderPag();
    }
    grid.addEventListener('click', function (e) {
      if (e.target.classList.contains('skr-img')) { lbOpen(e.target.src, e.target.getAttribute('data-cap') || ''); }
      if (e.target.classList.contains('skr-more')) { var p = e.target.previousElementSibling; p.classList.remove('skr-clamp'); e.target.remove(); }
    });

    // Paginación numerada con ventana ±2 + primera/última.
    var pag = q('[data-skr-pag]');
    function pageBtns() {
      var out = [], w = 3, s = new Set([1, pages]), j;
      for (j = page - w; j <= page + w; j++) { if (j >= 1 && j <= pages) { s.add(j); } }
      var arr = Array.from(s).sort(function (a, b) { return a - b; });
      for (j = 0; j < arr.length; j++) { if (j > 0 && arr[j] - arr[j - 1] > 1) { out.push('...'); } out.push(arr[j]); }
      return out;
    }
    function renderPag() {
      if (pages < 2) { pag.innerHTML = ''; return; }
      var h = '<button data-p="first" aria-label="Primera página" ' + (page === 1 ? 'disabled' : '') + '>&laquo;</button>';
      h += '<button data-p="prev" aria-label="Anterior" ' + (page === 1 ? 'disabled' : '') + '>&lsaquo;</button>';
      var b = pageBtns(), j;
      for (j = 0; j < b.length; j++) {
        if (b[j] === '...') { h += '<span class="skr-dots">&hellip;</span>'; }
        else { h += '<button data-p="' + b[j] + '" class="' + (b[j] === page ? 'skr-cur' : '') + '" aria-label="Página ' + b[j] + '">' + b[j] + '</button>'; }
      }
      h += '<button data-p="next" aria-label="Siguiente" ' + (page === pages ? 'disabled' : '') + '>&rsaquo;</button>';
      h += '<button data-p="last" aria-label="Última página" ' + (page === pages ? 'disabled' : '') + '>&raquo;</button>';
      pag.innerHTML = h;
    }
    pag.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b || b.disabled) { return; }
      var p = b.getAttribute('data-p');
      if (p === 'first') { page = 1; }
      else if (p === 'last') { page = pages; }
      else if (p === 'prev') { page = Math.max(1, page - 1); }
      else if (p === 'next') { page = Math.min(pages, page + 1); }
      else { page = Number(p); }
      render();
      var band = q('[data-skr-band]');
      var y = band.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });

    render();
  }

  function boot(root) {
    var nodes = (root || document).querySelectorAll('[data-skr-root]');
    Array.prototype.forEach.call(nodes, initSkr);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target || document); });
})();
